module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "img-pop"
  }, [_c('p', [_vm._v("请输入验证码")]), _vm._v(" "), _c('div', {
    staticClass: "code-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.getFocus($event)
      },
      "blur": _vm.fixWindow,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "img-code-btn",
    style: ({
      backgroundImage: 'url(' + _vm.imgCode + ')'
    }),
    on: {
      "click": _vm.getImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap",
    on: {
      "touchstart": _vm.getCode
    }
  }, [_c('span', {
    staticClass: "pop-btn"
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "img-mask"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e485641!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/component/imgCode.vue
// module id = 160
// module chunks = 2